import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../services/data.service';
import { NgApexchartsModule } from "ng-apexcharts";
import { 
  ApexAxisChartSeries, ApexNonAxisChartSeries,
  ApexChart, 
  ApexXAxis,
  ApexDataLabels,
  ApexLegend
} from "ng-apexcharts";


@Component({
  selector: 'app-ppl-content',
  imports: [CommonModule, NgApexchartsModule],
  templateUrl: './ppl-content.component.html',
  styleUrls: ['../tchr-content/tchr-content.component.scss', './ppl-content.component.scss']
})
export class PplContentComponent {
  @Input() user: any;
  loading = false;
  allData: any = [];
  tot_std: number = 0;
  tot_staff: number = 0;


  public chart1: ApexChart = {
    type: "area",
    height: 300,
    toolbar: {
        show: false
    }
  };
  public series1: ApexAxisChartSeries = [{
    name: "Revenue", data: [4, 5, 6, 8, 7, 9, 10, 12, 11, 13, 14, 16]
  }];
  public xaxis1: ApexXAxis = {
    categories: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  };
  public dataLabels1: ApexDataLabels = {enabled: false};

  public chart2: ApexChart = {type: "donut", height: 320};
  public series2: ApexNonAxisChartSeries = [94, 6];
  public labels2 = ['Present', 'Absent'];
  public legend2: ApexLegend = {'position': 'bottom'};
  public colors2 = ['#10b981', '#ef4444'];

  public chart3: ApexChart = {
    type: "bar",
    toolbar: {
        show: false
    }
  };
  public series3: ApexNonAxisChartSeries = [{
    name: 'Students', data: [1200, 1450, 1600, 1900, 2200, 2540]
  }];
  public xaxis3: ApexXAxis = {
    categories: ['2021','2022','2023','2024','2025','2026']
  };

  public chart4: ApexChart = {type: "radialBar", height: 320};
  public series4: ApexNonAxisChartSeries = [82];
  public labels4 = ['Collected'];
  public colors4 = ['#f59e0b'];
  
  constructor(
    // public auth: AuthService, 
    // public alertService: AlertConfirmService, 
    public dataService: DataService,
    // private modalService: ModalService
  ) {
    //
  }
  
  async ngOnInit() {
    this.loading = true;
    await this.dataService.getAllRecords('dash-principal').then((res: any) => {
      this.allData = res;

      this.tot_std = this.allData.std_cnt;
      this.tot_staff = this.allData.staff_cnt;

			this.loading = false;
    });
  }

}
